import { render, staticRenderFns } from "./succeed.vue?vue&type=template&id=51dcbe4a&scoped=true"
import script from "./succeed.vue?vue&type=script&setup=true&lang=js"
export * from "./succeed.vue?vue&type=script&setup=true&lang=js"
import style0 from "./succeed.vue?vue&type=style&index=0&id=51dcbe4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dcbe4a",
  null
  
)

export default component.exports